const SCORM_UPLOAD = 'SCORM_UPLOAD'
const SCORM_UPLOAD_SUCCESS = 'SCORM_UPLOAD_SUCCESS'
const SCORM_UPLOAD_ERROR = 'SCORM_UPLOAD_ERROR'
const SCORM_REPLACE = 'SCORM_REPLACE'
const SCORM_REPLACE_SUCCESS = 'SCORM_REPLACE_SUCCESS'
const SCORM_REPLACE_ERROR = 'SCORM_REPLACE_ERROR'
const SCORM_DELETE = 'SCORM_DELETE'
const SCORM_DELETE_SUCCESS = 'SCORM_DELETE_SUCCESS'
const SCORM_DELETE_ERROR = 'SCORM_DELETE_ERROR'
const SCORM_TRACK = 'SCORM_TRACK'
const SCORM_TRACK_SUCCESS = 'SCORM_TRACK_SUCCESS'
const SCORM_TRACK_ERROR = 'SCORM_TRACK_ERROR'

export {
  SCORM_UPLOAD,
  SCORM_UPLOAD_SUCCESS,
  SCORM_UPLOAD_ERROR,
  SCORM_REPLACE,
  SCORM_REPLACE_SUCCESS,
  SCORM_REPLACE_ERROR,
  SCORM_DELETE,
  SCORM_DELETE_SUCCESS,
  SCORM_DELETE_ERROR,
  SCORM_TRACK,
  SCORM_TRACK_SUCCESS,
  SCORM_TRACK_ERROR,
}
